import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import shareInfo from "./wx";
Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: "/",
        component: () => import("../views/index/index.vue"),
    },
    {
        path: "/jinrong",
        component: () => import("../views/jinrong/jinrong.vue"),
    },
    {
        path: "/chuangtou",
        component: () => import("../views/chuangtou/chuangtou.vue"),
    },
    {
        path: "/ziben",
        component: () => import("../views/ziben/ziben.vue"),
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((to, from) => {
    if (process.env.NODE_ENV == "production") {
        shareInfo.init({
            title: "2021中国资本市场高质量发展峰会 | 每日经济新闻",
            desc: "创新驱动，行稳致远。11月8日深圳共叙未来",
            img: "http://www.nbd.com.cn/corp/2021jrsign/images/share.jpg",
            shareURL: "http://www.nbd.com.cn/corp/20211108jdj/index.html",
        });
    }
});

export default router;
